import React from 'react';

/**
 * Cofactor brand mark — "Bauhaus Venn": two overlapping circles with the
 * intersection knocked out so the page background shows through. Mirrors
 * `@chatsdet/marketing-ui` LogoMark, but the accent disc uses the app theme's
 * primary token instead of the marketing site's `--accent` variable.
 */
export function CofactorMark({ size = 24, className }: { size?: number; className?: string }) {
  const id = React.useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;
  return (
    <svg
      className={className}
      width={Math.round((size * 4) / 3)}
      height={size}
      viewBox="0 0 80 60"
      fill="none"
      aria-hidden="true"
      style={{ display: 'inline-block', flexShrink: 0 }}
    >
      <defs>
        <clipPath id={clipId}>
          <circle cx="28" cy="30" r="22" />
        </clipPath>
        <mask id={maskId}>
          <circle cx="28" cy="30" r="22" fill="#fff" />
          <circle cx="52" cy="30" r="22" fill="#fff" />
          {/* knock out the intersection so the background shows through */}
          <circle cx="52" cy="30" r="22" fill="#000" clipPath={`url(#${clipId})`} />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        <circle cx="28" cy="30" r="22" fill="currentColor" />
        <circle cx="52" cy="30" r="22" fill="hsl(var(--primary))" />
      </g>
    </svg>
  );
}
